import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';
import {mc} from '@px/helper/mc';

interface PageResult<T> {
  total: number;
  rows: T[];
}
export interface GridCreateParams {
  copyFrom?: string;
  copyType?: string;
  strategyType: StrategyType;
  symbol: string;
  direction: GridDirection;
  gridCnt: number;
  initBalance: number | string;
  leverage: number | string;
  upperLimit: number;
  lowerLimit: number;
  currency: string;
  lastPrice: number | string;
  mode: GridMode;
  slPrice?: number;
  slPriceType?: TriggerTypeMarket | '';
  tpPrice?: number;
  tpPriceType?: TriggerTypeMarket | '';
  triggerPrice?: number;
  triggerPriceType?: TriggerTypeMarket | '';
  profitReinvestEnabled?: Boolean; //默认false，true为开启利润复投
}

interface StrategyListQuery {
  strategyType: StrategyType;
  symbol?: string;
}

export const strategyApi = {
  availableSymbol(query: {strategyType: StrategyType}) {
    return http.get<{code: number; symbol: string}[]>(API_URLS.STRATEGY_AVAILABLE_SYMBOL, {query});
  },
  createConfig(query: {strategyType: StrategyType; symbol: string}) {
    return http.get<{minGridCnt: number; maxGridCnt: number; maxLeverage: number}>(API_URLS.STRATEGY_CREATE_CONFIG, {query});
  },
  recommendList(query: StrategyListQuery) {
    return http.get<StrategyGridRecommend[]>(query.strategyType === 'CONTRACT_MARTIN' ? API_URLS.STRATEGY_MARTIN_RECOMMEND_LIST : API_URLS.STRATEGY_RECOMMEND_LIST, {
      query,
      formatter: (res) => {
        res.forEach((e) => {
          e.profitHistory = e.profitHistory || [];
        });
        return res;
      },
    });
  },
  recommendDetail(query: {strategyId: string; recType: string}) {
    return http.get<StrategyGridRecommend>(API_URLS.STRATEGY_RECOMMEND_DETAIL, {query});
  },
  async create(params: GridCreateParams) {
    const res = await http.post(API_URLS.STRATEGY_CREATE, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  openList(query: StrategyListQuery) {
    return http.get<StrategyGridActive[]>(API_URLS.STRATEGY_OPEN_LIST, {query});
  },
  historyList(query: StrategyListQuery & {page: number; pageSize: number}) {
    return http.get<PageResult<StrategyGridHistory>>(API_URLS.STRATEGY_HISTORY_LIST, {query});
  },
  increaseBalance(params: {amount: number; currency: string; strategyId: string}) {
    return http.post(API_URLS.STRATEGY_INCREASE_BALANCE, {params});
  },
  updateStrategyTpsl(params: {strategyId: string; slPrice?: number; slPriceType?: TriggerTypeMarket; tpPrice?: number; tpPriceType?: TriggerTypeMarket}) {
    return http.post(API_URLS.STRATEGY_UPDATE_TPSL, {params});
  },
  updateStrategyTrigger(params: {strategyId: string; triggerPrice: number; triggerPriceType: TriggerTypeMarket; lastPrice: string}) {
    return http.post(API_URLS.STRATEGY_UPDATE_TRIGGER, {params});
  },
  async start(params) {
    const res = await http.post(API_URLS.STRATEGY_START, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  async stop(params) {
    const res = await http.post(API_URLS.STRATEGY_STOP, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  async martinCreate(params) {
    const res = await http.post(API_URLS.STRATEGY_MARTIN_CREATE, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  martinHistoryList(query: StrategyListQuery & {page: number; pageSize: number}) {
    return http.get<PageResult<StrategyGridHistory>>(API_URLS.STRATEGY_MARTIN_HISTORY_LIST, {query});
  },
  martinTpSl(params) {
    return http.post(API_URLS.STRATEGY_MARTIN_TPSL, {params});
  },
  martinStrategyDetail(query) {
    return http.get<StrategyGridRecommend>(API_URLS.STRATEGY_MARTIN_DETAIL, {query});
  },
  signalCreate(params) {
    return http.post(API_URLS.STRATEGY_SIGNAL_CREATE, {params});
  },
  signalUpdate(params) {
    return http.post(API_URLS.STRATEGY_SIGNAL_UPDATE, {params});
  },
  signalDelete(params) {
    return http.post(API_URLS.STRATEGY_SIGNAL_DELETE, {params});
  },
  signalDetail(query) {
    return http.get(API_URLS.STRATEGY_SIGNAL_DETAIL, {query});
  },
  signalListQuery(query) {
    return http.get(API_URLS.STRATEGY_SIGNAL_LIST, {query});
  },
  signalStrategyCreate(params) {
    return http.post(API_URLS.STRATEGY_SIGNAL_STRATEGY_CREATE, {params});
  },
  signalStrategyAdjustTpsl(params) {
    return http.post(API_URLS.STRATEGY_SIGNAL_STRATEGY_ADJUST_TPSL, {params});
  },
  signalStrategyHistory(query) {
    return http.get(API_URLS.STRATEGY_SIGNAL_STRATEGY_HISTORY, {query});
  },
  async martinUpdateStartCondition(params) {
    const res = await http.post(API_URLS.STRATEGY_MARTIN_UPDATE_START_CONDITION, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  async martinUpdateStopCondition(params) {
    const res = await http.post(API_URLS.STRATEGY_MARTIN_UPDATE_STOP_CONDITION, {params});
    if (res.error) {
      mc.send('toast', 'error', res.error);
    }
    return res;
  },
  strategyGridBackTest(params) {
    return http.post(API_URLS.STRATEGY_GRID_BACK_TEST, {params});
  },
};
